import { render, staticRenderFns } from "./aibot.vue?vue&type=template&id=56205cb8&scoped=true"
import script from "./aibot.vue?vue&type=script&lang=js"
export * from "./aibot.vue?vue&type=script&lang=js"
import style0 from "./aibot.vue?vue&type=style&index=0&id=56205cb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56205cb8",
  null
  
)

export default component.exports